import React, { useState } from 'react';

const AccordionItem = ({ title, children, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="tw-border-b tw-border-gray-200 last:tw-border-b-0">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="tw-w-full tw-flex tw-items-center tw-justify-between tw-py-5 tw-px-1 tw-text-left tw-bg-transparent tw-border-0 tw-cursor-pointer tw-group"
      >
        <span className="tw-text-sm tw-font-medium tw-text-gray-800 group-hover:tw-text-primary-600 tw-transition-colors tw-pr-4">
          {title}
        </span>
        <svg
          className={`tw-w-5 tw-h-5 tw-text-gray-400 tw-flex-shrink-0 tw-transition-transform tw-duration-200 ${isOpen ? 'tw-rotate-180' : ''}`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      <div
        className={`tw-overflow-hidden tw-transition-all tw-duration-300 ${isOpen ? 'tw-max-h-96 tw-opacity-100' : 'tw-max-h-0 tw-opacity-0'}`}
      >
        <div className="tw-pb-5 tw-px-1 tw-text-sm tw-text-gray-600 tw-leading-relaxed">
          {children}
        </div>
      </div>
    </div>
  );
};

const Accordion = ({ children, className = '' }) => {
  return (
    <div className={`tw-divide-y tw-divide-gray-200 ${className}`}>
      {children}
    </div>
  );
};

Accordion.Item = AccordionItem;

export default Accordion;
